module Widgets.Form.Select where

import Common

import Concur.React.DOM as D
import Concur.React.Props as P
import Data.Argonaut as J
import GraphQL.Shape (QueryField(..))
import Widgets.BetterSelect (Select, SelectOption, initSimpleSelect, selectWidget, selectedItem, setSelected)
import Widgets.Form.Class (class FormWidget, fieldCanUpdate, formWidgetState, fieldClass, fieldId)
import Widgets.Form.Common (widgetLabelM)


-- | Type of the `value` field in `options`.
type SelectEntry = Json

newtype SelectWidget = SelectWidget SelectType
instance showSelect :: Show SelectWidget where
    show (SelectWidget s) = "Select " <> s.id
type SelectType = SelectBase ( sel :: Select SelectEntry )
type SelectWidgetOption = SelectOption SelectEntry

type SelectBase r =
    { id :: String
    , label :: Maybe String
    , cls :: String
    , options :: Array (SelectOption SelectEntry)
    , placeholder :: Maybe String
    | r }

type SelectInit = SelectBase ( value :: Maybe SelectEntry )

initSelectWidget :: SelectInit -> SelectWidget
initSelectWidget { id, label, options, value, cls, placeholder } = setSelected' value $ SelectWidget
    { id, label, options, cls, placeholder
    , sel: (initSimpleSelect id options) { config { placeholder = placeholder } }
    }

setSelected' :: Maybe SelectEntry -> SelectWidget -> SelectWidget
setSelected' entry (SelectWidget state) = SelectWidget $ state
    { sel = setSelected state.sel opt }
  where
    opt :: Maybe (SelectOption SelectEntry)
    opt = do
       json <- entry
       -- Find the label by searching the list of options for a matching value.
       option <- find (\o -> o.value == json) state.options
       pure { label: option.label, value: json }


instance selectFW :: FormWidget SelectWidget where
    getId (SelectWidget state) = state.id
    isLeaf _ = true
    asField (SelectWidget state) = Just $ QScalar state.id
    fieldPaths fc (SelectWidget state) = [ fieldId fc state.id ]

    toWidget fc (SelectWidget state) = formWidgetState <$> SelectWidget <$> state' { sel = _ }
        <$> D.div
            [ P.className $ fieldClass state, P.key state.id ]
            [ widgetLabelM fc state [ P.className "block w-full" ]
            -- HACK: When rendering this, we have to add the parent IDs here
            -- instead of at parse time, so we insert them into the state here.
            -- When the select widget returns the state, we put the old
            -- unqualified ID back so we don't end up stacking the parent IDs
            -- on multiple times.
            , selectWidget state'.sel
            ]
      where
        state' = state
            { sel { id = fieldId fc state.id, config { editable = fieldCanUpdate fc state.id } } }

    getData _ (SelectWidget state) =
        fromMaybe J.jsonNull (_.value <$> selectedItem state.sel)
    setData _ state json | J.isNull json = Right $ setSelected' Nothing state
    setData _ state json = Right $ setSelected' (Just json) state
